import { useNavigate } from 'react-router-dom'
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import StatsSummary from '../StatsSummary'
import ComponentsSelect from './components/Components'
import LabelsSelect from './components/Labels'
import { formatVersionLabel } from '../../utils/formatVersionLabel'
import PageLink from 'components/common/PageLink'
import TraceFile from './components/TraceFile'

const DetailsAccordion = ({ testCase, testRuns, compact = false }) => {
  const navigate = useNavigate()

  const failedTotal = testRuns.filter(tr => tr.status === "FAILED").length
  const passedTotal = testRuns.filter(tr => tr.status === "COMPLETED").length
  const issueRate = testRuns.length
    ? ((failedTotal/testRuns.length) * 100).toFixed(2)
    : 'N/A'

  const handleChangeVersion = (versionId) => {
    navigate(`/test-case/${versionId}`, { replace: true })
  }

  return <Box className='detailsAccordionContainer'>
    <Accordion className='detailsAccordion' defaultExpanded>
      <AccordionSummary className='detailsAccordionSummary' expandIcon={<ExpandMoreIcon/>}>
        <Typography className='detailsAccordionSummaryTitle'>Details</Typography>
      </AccordionSummary>
      <AccordionDetails className='detailsAccordionContent'>
        <Box className='detailsAccordionContentTopSection'>
          <PageLink link={testCase?.pageUrl}/>
          { testCase?.versions.length > 1 ?
            <Box className="detailsAccordionVersionsContainer">
              <FormControl>
                <InputLabel>Versions</InputLabel>
                <Select
                  size='small'
                  value={testCase.id}
                  onChange={(e) => handleChangeVersion(e.target.value)}
                  label="Versions"
                  sx={{ width: '340px', maxWidth: '340px' }}
                >
                  { testCase.versions.map(
                    version =>
                      <MenuItem key={version.id} value={version.id}>
                        {formatVersionLabel(version.id, testCase.versions)}
                      </MenuItem>)
                  }
                </Select>
              </FormControl>
            </Box> : null
          }
        </Box>
        <Box className="detailsAccordionPageDescriptionContainer">
          <Typography variant="body1" color="primary">
            <span className="detailsAccordionPageDescriptionLabel">Description: </span>
            {testCase?.description}
          </Typography>
        </Box>
        {testRuns && testRuns.length &&
          <TraceFile
            traceRuns={testRuns.filter((item) => item.aws_tracing_url)}
            compact={compact}
          />
        }
        <Divider/>
        <Box className="detailsAccordionStatsContainer">
          <StatsSummary title="Total Runs" value={testRuns.length} color="primary"/>
          <StatsSummary title="Times Failed" value={failedTotal} color="primary"/>
          <StatsSummary title="Times Passed" value={passedTotal} color="primary"/>
          <StatsSummary
            title="Issue Rate"
            value={issueRate !== "N/A" ? `${issueRate}%` : issueRate}
            color={issueRate > 0 ? "#d32f2f" : "primary"}
          />
          <StatsSummary
            title="Created by"
            value={testCase?.created_by || "-"}
            color="primary"
          />
        </Box>
        <Box className="detailsAccordionBottomSection">
          {testCase && testCase.projectId && testCase.id && 
            <Box sx={{
              display: 'grid', 
              gridTemplateColumns: '1fr 1fr', 
              gap: '16px', 
              flex: 1, 
              flexDirection: 'row', 
              alignItems: 'center', 
              justifyContent: 'space-between'
            }}>
              <ComponentsSelect 
                projectId={testCase.projectId}
                testCaseId={testCase.id}
              />
              <LabelsSelect 
                projectId={testCase.projectId}
                testCaseId={testCase.id}
              />
            </Box>
          }
        </Box>
      </AccordionDetails>
    </Accordion>
  </Box>
}

export default DetailsAccordion
